import { EyeOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { Button, Tooltip } from 'antd';
import * as React from 'react';
import { resolveApiPath } from '../../../../../core/appConfig';
import { IPublicAreaFile } from './getTableTreeDataFromCartelle';

export interface IPublicFileDownloadButtonProps {
  record: IPublicAreaFile;
}

export function PublicFileDownloadButton(
  props: IPublicFileDownloadButtonProps,
) {
  const { record } = props;
  const { t } = useTranslation();

  return (
    <Tooltip
      title={t(
        'observation-details.apri-documento',
        `Apri Documento {{record}}`,
        { record: record.nome ? `"${record.nome}"` : '' },
      )}
    >
      <Button
        type="link"
        size="large"
        aria-label={`Apri Documento ${record.nome}`}
        icon={<EyeOutlined aria-hidden />}
        target="_blank"
        rel="noopener noreferrer"
        href={resolveApiPath(record.url!)}
      />
    </Tooltip>
  );
}
